import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { HARDCOPY_MAX_QTY, HARDCOPY_MIN_QTY, HARDCOPY_PRICE } from '../../settings';
import { HardcopyCustomerDetailsPage } from '../customer-details/customer-details';
import { FirebaseAnalytics } from '@ionic-native/firebase-analytics';

@Component({
    selector: 'page-hardcopy-quantity',
    templateUrl: 'quantity.html'
})

export class HardcopyQuantityPage {

    public editMode: boolean = false;
    public qty: number = 1;
    public saveCallback: (qty: number) => void;

    constructor(
        public analytics: FirebaseAnalytics,
        public navCtrl: NavController,
        public navParams: NavParams,
    ) {
        this.editMode = navParams.get('editMode') || false;

        if (this.editMode) {
            this.qty = navParams.get('qty');
            this.saveCallback = navParams.get('saveCallback');
        }
    }

    public ionViewDidEnter() {
        this.analytics.setCurrentScreen('HardcopyQuantity');
        this.analytics.logEvent('begin_checkout', {});
        this.analytics.logEvent('checkout_progress', {
            checkout_step: 1
        });
    }

    public decreaseQty() {
        this.setQty(this.qty - 1);
    }

    public getDisplayQty(): string {
        let qty = this.qty.toString();

        while (qty.length < 2) {
            qty = '0' + qty;
        }

        return qty;
    }

    public increaseQty() {
        this.setQty(this.qty + 1);
    }

    public setQty(qty: number) {
        if (qty > HARDCOPY_MAX_QTY) qty = HARDCOPY_MAX_QTY;
        if (qty < HARDCOPY_MIN_QTY) qty = HARDCOPY_MIN_QTY;
        this.qty = qty;
    }

    public next() {
        this.analytics.logEvent('add_to_cart', {
            item_category: 'hardcopy',
            item_id: 'hardcopy_2020',
            item_name: 'Ireland - A Directory 2020',
            quantity: this.qty,
        });
        this.navCtrl.push(HardcopyCustomerDetailsPage, {
            qty: this.qty
        });
    }

    public save() {
        if (this.saveCallback) this.saveCallback(this.qty);
        this.navCtrl.pop();
    }

}



// WEBPACK FOOTER //
// ./src/pages/purchase-hardcopy/pages/quantity/quantity.ts